import { getVaSessionUrl, getHpSmartUrl } from '@uma/react-commons/dist/index';

const BASE_HP_SHOP_URL = 'https://www.hp.com/us-en/shop/';

const PAGE_ID = 'Subscriptions';

export const getImMissingInkUrl = async (
  language: string = 'en',
  country: string = 'us'
): Promise<string> => {
  return getVaSessionUrl({
    language,
    country,
    botContext: {
      query: 'ii_inkDelivery',
      pageId: PAGE_ID
    }
  });
};

export const getMyBillWasNotWhatIExpected = async (
  language: string = 'en',
  country: string = 'us'
): Promise<string> => {
  return getVaSessionUrl({
    language,
    country,
    botContext: {
      query: 'ii_billingIssue',
      pageId: PAGE_ID
    }
  });
};

export const URLS = {
  UnifiedShippingBillingURL: `${getHpSmartUrl()}/account-details/shipping-billing`,
  ManageYourAllInPlan: `${getHpSmartUrl()}/hp-all-in-print-plan/update-plan`,
  AllInShipment: `${getHpSmartUrl()}/hp-all-in-print-plan/shipment-tracking`,
  AccountHistoryAllIn: `${getHpSmartUrl()}/account-details/statements`,
  CancelHPAllIn: `${getHpSmartUrl()}/hp-all-in-print-plan/cancellation`,
  CancelHPInstantInk: `${getHpSmartUrl()}/print_plans/cancellation`,
  InkShipment: `${getHpSmartUrl()}/print_plans/ink_shipment`,
  AccountHistoryInk: `${getHpSmartUrl()}/print_plans/account_history`,
  ManageYourInstantInkPlan: `${getHpSmartUrl()}/print_plans/my_account`,
  InstantInkOverview: `${getHpSmartUrl()}/print_plans`,
  HpAllInOverview: `${getHpSmartUrl()}/hp-all-in-print-plan/overview`,
  ProLiveSupport: 'https://support.hp.com/us-en/service/all-in-plan/2101795773',
  HPShop: `${BASE_HP_SHOP_URL}LogonForm`,
  HPStoreSubscriptions: `${BASE_HP_SHOP_URL}MySubscriptionsView?catalogId=10051&storeId=10151&langId=-1`,
  GetInstantInkSupport: `https://support.hp.com/us-en/service/hp-instant-ink-series/5264756`
};
